/* eslint-disable @typescript-eslint/no-explicit-any */
// TODO: This file was automatically migrated to TypeScript by `dev typescript migrate`.
//  The eslint disable comment above should be removed and the resulting errors fixed.
import {clamp} from '@benchling/js-utils';
import {css, StyleSheet} from 'aphrodite';
import classNames from 'classnames';
import reactUpdate from 'immutability-helper';
import $ from 'jquery';
import React from 'react';
import ReactDOM from 'react-dom';
import isEqual from 'react-fast-compare';
import _ from 'underscore';

import {assert} from 'Asserts';
import getTestProps from 'test/lib/cypress/getTestProps';
import DataTestAttrs from 'test/lib/cypress/shared/DataTestAttrs';
import ClickOutWrapper from 'ui-library/ClickOutWrapper';
import {GRAY_LIGHT} from 'ui-library/Colors';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';
import {TagsInputSize} from 'ui-library/tags-input/TagsInputConstants';
import * as keyboard from 'util/Keyboard';

interface TagsInputDropdownOptionProps {
  children: React.ReactNode;
}

export function TagsInputDropdownOption({children}: TagsInputDropdownOptionProps): JSX.Element {
  return <div className="tagsInput-dropdown-option">{children}</div>;
}

/*
(ts-migrate) TODO: Migrate the remaining prop types
button({button, size}) {
      if (button != null && button.props.size !== size) {
        return new Error('Button size and input size do not match');
      }
      return null;
    }
*/
export interface LegacyTagsInputProps {
  className?: string;
  value: Array<{
    text?: string;
    id: string;
  }>;
  button?: JSX.Element;
  onChange: (...args: Array<any>) => any;
  onKeyDown?: (...args: Array<any>) => any;
  placeholder: string;
  inputClass?: string;
  displayTransform?: (...args: Array<any>) => any;
  size: TagsInputSize;
  addKeys?: Array<number>;
  allOptions?: Array<{
    id: string;
    text?: string;
  }>;
  allowAdding?: boolean;
  allowAdjustInputWidth?: boolean;
  allowSearching?: boolean;
  closeDropdownOnSelect?: boolean;
  filterOptions?: (...args: Array<any>) => any;
  isOptionSelectable?: (...args: Array<any>) => any;
  noMatchingOptions?: any;
  onChangeInput?: (...args: Array<any>) => any;
  onHoverOption?: (...args: Array<any>) => any;
  renderOption?: (...args: Array<any>) => any;
  shouldAllowMultiple?: boolean;
  // The attributes are for the input and not the options
  dataTestAttrs?: DataTestAttrs;
  disabled?: boolean;
}

type LegacyTagsInputState = any;

// Legacy, please use ChipSelectInput.tsx instead if possible.

// LegacyTagsInput is a component used for selecting multiple options from a dropdown. The component handles
// showing selected options, adding and removing selected options via keydown and click handlers. The parent
// component handles generating and rendering options, and handling actions when tags are added or removed.
// Note: The component can also be used for single option selection with `value = []` and setting the
// `onChange` handler to handle each option addition.
class LegacyTagsInput extends React.Component<LegacyTagsInputProps, LegacyTagsInputState> {
  static defaultProps = {
    allowAdding: true,
    allowAdjustInputWidth: true,
    allowSearching: true,
    addKeys: [13, 9], // Enter and tab
    closeDropdownOnSelect: false,
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    displayTransform(option: any) {
      return option.text;
    },
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    filterOptions(query: any, options: any) {
      if (query.length === 0) {
        return options;
      }
      const queryTerms = query.toLowerCase().split(/\s+/);
      const matchingOptions = options.filter((option: any) =>
        queryTerms.every((term: any) => option.text.toLowerCase().indexOf(term) !== -1)
      );
      return matchingOptions;
    },
    noMatchingOptions: <TagsInputDropdownOption>No options found by that name</TagsInputDropdownOption>,
    renderOption({text}: any): JSX.Element {
      return <TagsInputDropdownOption>{text}</TagsInputDropdownOption>;
    },
    shouldAllowMultiple: true,
  };

  override state: LegacyTagsInputState = {
    hoverIndex: -1,
    isInputFocused: false,
    // If non-null, try to focus the tag at this index on the next component update.
    tagIndexPendingFocus: null,
    text: '',
  };

  override refs!: {
    [key: string]: HTMLLIElement;
  };

  scrollAreaRef = React.createRef<HTMLDivElement>();
  inputRef = React.createRef<HTMLInputElement>();

  override componentDidUpdate(prevProps: LegacyTagsInputProps, prevState: LegacyTagsInputState): void {
    // Grab focus on the newly added tag if cloesDropdownOnSelect and the new tag has mounted.
    if (
      this.props.closeDropdownOnSelect &&
      this.state.tagIndexPendingFocus != null &&
      this.state.tagIndexPendingFocus < this.props.value.length
    ) {
      const ref = this.refs[this._getTagRefByIndex(this.state.tagIndexPendingFocus)];
      if (ref) {
        ref.focus();
        this.setState({tagIndexPendingFocus: null});
      }
    }
    const prevMatchingOptions = this.getMatchingOptions(
      prevProps.allOptions,
      prevProps.filterOptions,
      prevState.text
    );
    const matchingOptions = this.getMatchingOptions(
      this.props.allOptions,
      this.props.filterOptions,
      this.state.text
    );
    if (isEqual(prevMatchingOptions, matchingOptions)) {
      return;
    }
    if (this.props.onHoverOption != null) {
      // Inform the parent component that the hovered option has changed.
      const hoveredOption = matchingOptions[this.state.hoverIndex];
      this.props.onHoverOption(hoveredOption || {text: this.state.text});
    }
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type
  getMatchingOptions = (allOptions: any, filterOptions: any, text: any) => {
    if (text == null) {
      text = '';
    }
    if (allOptions == null || allOptions.length === 0) {
      return [];
    }
    return filterOptions(text, allOptions);
  };

  addOption = (option: any): boolean => {
    assert(Boolean(this.props.allowAdding || this.props.allowSearching), 'cannot add option');
    if (!this.isOptionSelectable(option)) {
      return false;
    }
    const value = reactUpdate(this.props.value, {$push: [option]});
    // Clear input text and reset filter
    this._handleChangeHoverAndText(-1, '');
    this.props.onChange(value);
    // If `closeDropdownOnSelect`, select the newly added option, which causes the input to blur.
    // This dropdown open state is tied to isInputFocused, so blurring the input will close the dropdown.
    if (this.props.closeDropdownOnSelect) {
      this.setState({
        isInputFocused: false,
        tagIndexPendingFocus: value.length - 1,
      });
    }
    return true;
  };

  // We auto-hover the first option when an input changes. While this makes sense for the user experience
  // (most relevant options should show), this requires us to pair hover and text state. Prefer handling
  // both state updates in one function since we consider the input value the "hovered option" if there are no
  // matching options.
  _handleChangeHoverAndText = (hoverIndex: any, text?: any): void => {
    const newState: {
      hoverIndex: number;
      text?: string;
    } = {hoverIndex};
    // Update the new state if the input value has changed.
    if (text != null) {
      newState.text = text;
      if (typeof this.props.onChangeInput === 'function') {
        this.props.onChangeInput(text);
      }
    }
    this.setState(newState);
    if (this.props.onHoverOption != null) {
      const hoveredOption = this.getMatchingOptions(
        this.props.allOptions,
        this.props.filterOptions,
        this.state.text
      )[hoverIndex];
      this.props.onHoverOption(hoveredOption || {text: text || ''});
    }
  };

  isOptionSelectable = (option: any): boolean => {
    if (this.props.isOptionSelectable != null) {
      return this.props.isOptionSelectable(option);
    }
    return !this.isOptionSelected(option);
  };

  // eslint-disable-next-line no-restricted-syntax
  isOptionSelected = (option: any): boolean => _.pluck(this.props.value, 'id').includes(option.id);

  removeOption = (option: any, e: any): boolean => {
    e.stopPropagation();
    // eslint-disable-next-line no-restricted-syntax
    const value = _.without(this.props.value, option);
    this.props.onChange(value);
    return true;
  };

  _handleChangeInput = (e: any): void => {
    const text = e.target.value;
    // Hover on the first option. While 0 may be invalid hover index when there are no options shown,
    // we want to optimistically select the first option. Valid options can update on the next render,
    // and we'd prefer to try to select the first option than not selecting anything.
    this._handleChangeHoverAndText(0, text);
  };

  _handleKeyDownInput = (e: any): void => {
    let newIndex;
    let shouldParentHandleKeydown;
    const matchingOptions = this.getMatchingOptions(
      this.props.allOptions,
      this.props.filterOptions,
      this.state.text
    );
    if (this.props.addKeys!.includes(e.keyCode)) {
      if (matchingOptions.length && this.state.hoverIndex >= 0) {
        // Select the highlighted option
        e.preventDefault();
        this.addOption(matchingOptions[this.state.hoverIndex]);
      } else if (this.state.text !== '' && this.props.allowAdding) {
        // If no option is highlighted, try to submit text as an additional option
        e.preventDefault();
        this.addOption({text: this.state.text});
      } else if (this.state.text !== '' && this.props.allowSearching) {
        e.preventDefault();
      } else {
        shouldParentHandleKeydown = true;
      }
    } else if (keyboard.isADeleteKey(e) && this.state.text === '') {
      // Backspace or Delete with no text in the input
      this.removeOption(this.props.value[this.props.value.length - 1], e);
    } else if (keyboard.isUpKey(e)) {
      e.preventDefault();
      // Clamp at -1 to allow option deselection
      newIndex = clamp(-1, matchingOptions.length - 1, this.state.hoverIndex - 1);
      this.scrollIndexIntoView(newIndex);
      this._handleChangeHoverAndText(newIndex);
      return;
    } else if (keyboard.isDownKey(e)) {
      e.preventDefault();
      newIndex = clamp(-1, matchingOptions.length - 1, this.state.hoverIndex + 1);
      this.scrollIndexIntoView(newIndex);
      this._handleChangeHoverAndText(newIndex);
    }

    if (shouldParentHandleKeydown) {
      if (typeof this.props.onKeyDown === 'function') {
        this.props.onKeyDown(e);
      }
    }
  };

  _handleFocusInput = (): void => {
    this.setState({isInputFocused: true});
  };

  _handleBlurInput = (): void => {
    this.setState({isInputFocused: false});
  };

  _handleMouseDownOption = (e: any): void => {
    // Prevent option from stealing focus from the active input, since we listen to onBlur to control
    // the presence of the dropdown.
    e.preventDefault();
  };

  _handleKeyDownTag = (e: any): void => {
    if (keyboard.isADeleteKey(e)) {
      // Backspace or Delete with no text in the input
      this.removeOption(this.props.value[this.props.value.length - 1], e);
    }
  };

  scrollIndexIntoView = (index: any): void => {
    // Ignore cases where we clamped the index and it hasn't changed, and when no option is highlighted
    let offsetTop;
    if (index === this.state.hoverIndex || index < 0) {
      return;
    }

    const scrollArea = ReactDOM.findDOMNode(this.scrollAreaRef.current) as HTMLDivElement;
    const scrollAreaBox = scrollArea.getBoundingClientRect();
    const itemBox = (
      ReactDOM.findDOMNode(this.refs[this._getItemRefByIndex(index)]) as Element
    ).getBoundingClientRect();

    if (itemBox.top < scrollAreaBox.top) {
      offsetTop = itemBox.top - scrollAreaBox.top;
    } else if (itemBox.bottom > scrollAreaBox.bottom) {
      offsetTop = itemBox.bottom - scrollAreaBox.bottom;
    } else {
      // Item is already visible
      return;
    }

    $(scrollArea)
      .stop()
      .animate({scrollTop: scrollArea.scrollTop + offsetTop}, {duration: 150});
  };

  focus = (): void => {
    this.setState({isInputFocused: true}, () => {
      this.inputRef.current!.focus();
    });
  };

  _handleClickOut = (): void => {
    // Try to add the option (if its non-empty) when the input loses focus, in case the user clicks
    // submit without hitting an addKey first.
    if (this.props.allowAdding && this.state.text) {
      this.addOption({text: this.state.text});
    } else {
      // Reset the hover index on blur.
      this._handleChangeHoverAndText(-1);
    }
  };

  _getItemRefByIndex = (index: any): string => `item${index}`;

  _getTagRefByIndex = (index: any): string => `selected${index}`;

  override render(): JSX.Element {
    let style;
    const selectedOptions = this.props.value.map((option, i) => (
      <li
        className="tagsInput-tag"
        key={i}
        ref={this._getTagRefByIndex(i)}
        // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
        tabIndex={0}
        onKeyDown={this._handleKeyDownTag}
        {...getTestProps({component: 'LegacyTagsInput', element: 'listItem'})}
      >
        {this.props.displayTransform!(option)}
        <BenchlingIcon
          className="tagsInput-remove u-tiny-spacing-left"
          icon="close"
          onClick={this.removeOption.bind(null, option)}
        />
      </li>
    ));
    const matchingOptions = this.getMatchingOptions(
      this.props.allOptions,
      this.props.filterOptions,
      this.state.text
    );

    // getWidth estimates the width of the text/placeholder in the input, so we can display the input
    // as an inline-block element without it being cutoff. However, this results in a bug as the input
    // will grow with long text (setting `max-width: 100%` does not override width). If there are no
    // tags, the input can have width 100%, so we don't calculate the width if there are not values.
    const getWidth = (length: any): number => (length + 1) * 0.75;
    if (this.props.allowAdjustInputWidth && this.props.value.length > 0) {
      const width = Math.max(getWidth(this.state.text.length), getWidth(this.props.placeholder.length));
      style = {width: `${width}em`};
    }
    const canSelectAdditional = this.props.value.length === 0 || this.props.shouldAllowMultiple;

    // Use ClickOutWrapper so that if an inline button is clicked, we can preserve which option is hovered.
    return (
      <ClickOutWrapper onClickOut={this._handleClickOut}>
        <div
          className={classNames(this.props.className, 'u-flex-display')}
          {...getTestProps({component: 'LegacyTagsInput', element: 'root'})}
        >
          <div className="u-position-relative u-flex-grow">
            <div
              className={classNames(`tagsInput tagsInput--${this.props.size}`, {
                'tagsInput--inline': this.props.button != null,
                [css(styles.disabled)]: this.props.disabled,
              })}
              {...getTestProps({component: 'LegacyTagsInput', element: 'backgroundContainer'})}
            >
              <ul className="tagsInput-container">
                {selectedOptions}
                {canSelectAdditional && (
                  <li
                    className="tagsInput-inputWrapper"
                    style={style}
                    {...getTestProps({component: 'LegacyTagsInput', element: 'inputWrapper'})}
                  >
                    <input
                      // Chrome shows email auto-complete when the placeholder includes "email"; disable since
                      // we provide suggestions. Notably, auto-complete="off" does not work, so use this hack.
                      // https://stackoverflow.com/questions/15738259/disabling-chrome-autofill
                      autoComplete="new-password"
                      className={classNames('tagsInput-input', this.props.inputClass)}
                      ref={this.inputRef}
                      placeholder={this.props.placeholder}
                      onChange={this._handleChangeInput}
                      onKeyDown={this._handleKeyDownInput}
                      onFocus={this._handleFocusInput}
                      onBlur={this._handleBlurInput}
                      readOnly={!(this.props.allowAdding || this.props.allowSearching)}
                      value={this.state.text}
                      disabled={this.props.disabled}
                      {...getTestProps(this.props.dataTestAttrs)}
                    />
                    {
                      // Render the dropdown as a sibling to the input so we can use CSS selectors to
                      // change its display type based on input:focus. The dropdown is position:absolute,
                      // so this shouldn't affect layout.
                      this.state.isInputFocused &&
                        this.props.allOptions != null &&
                        (matchingOptions.length > 0 || this.state.text) && (
                          <div
                            className={classNames('tagsInput-dropdown')}
                            ref={this.scrollAreaRef}
                            {...getTestProps({component: 'LegacyTagsInput', element: 'dropdown'})}
                          >
                            {matchingOptions.length === 0
                              ? this.props.noMatchingOptions
                              : matchingOptions.map((option: any, i: any) => (
                                  <div
                                    className={classNames(
                                      'tagsInput-dropdown-option-container u-vertical-center-items u-lr-split',
                                      {'u-pointer': option.clickable},
                                      {'is-highlighted': this.state.hoverIndex === i}
                                    )}
                                    key={i}
                                    onClick={this.addOption.bind(null, option)}
                                    onMouseDown={this._handleMouseDownOption}
                                    onMouseOver={() => {
                                      this._handleChangeHoverAndText(i);
                                    }}
                                    ref={this._getItemRefByIndex(i)}
                                    {...getTestProps({
                                      component: 'LegacyTagsInput',
                                      element: 'matchingOption',
                                    })}
                                    aria-selected={this.state.hoverIndex === i}
                                    tabIndex={-1}
                                    role="option"
                                  >
                                    {this.props.renderOption!(option)}
                                    {this.isOptionSelected(option) && (
                                      <span className="tagsInput-dropdown-option-selected u-success-color">
                                        <BenchlingIcon icon="check" />
                                      </span>
                                    )}
                                  </div>
                                ))}
                          </div>
                        )
                    }
                  </li>
                )}
              </ul>
            </div>
          </div>
          {this.props.button && React.cloneElement(this.props.button, {className: 'button--inline'})}
        </div>
      </ClickOutWrapper>
    );
  }
}

Object.freeze(LegacyTagsInput);

export default LegacyTagsInput;

export const styles = StyleSheet.create({
  disabled: {backgroundColor: GRAY_LIGHT},
});
